export interface OptimizeTargetFields {
  target_auc?: number;
  target_type: string;
  target_value?: number;
  mic?: number;
}

export const buildOptimizeTargetFields = (
  selectedMethod: string,
  values: Record<string, number | null | undefined>,
  includeMicOverride = false,
): OptimizeTargetFields => {
  const targetFieldByMethod: Record<string, string> = {
    'AUC/MIC': 'target_auc_mic',
    '%fT>MIC': 'target_ft',
    'Target Concentration': 'target_cmin',
    'Target Cmax': 'target_cmax',
    'Cmax/MIC': 'target_cmax_mic',
  };
  const targetField = targetFieldByMethod[selectedMethod];
  return {
    target_auc: selectedMethod === 'Target AUC' ? (values.target_auc ?? undefined) : undefined,
    target_type: selectedMethod,
    target_value: targetField ? (values[targetField] ?? undefined) : undefined,
    mic: includeMicOverride ? (values.mic ?? undefined) : undefined,
  };
};
